import { CalendarAppointmentEvent } from 'components/mrp/components/Calendar/Calendar.types';
import dayjs from 'dayjs';
import {
  AppointmentSummary,
  ClientResponse,
  EmployeeResponse,
  EventResponse
} from 'generated/index';

type AppointmentSummaryAuditFields = AppointmentSummary & {
  createdBy?: string | number;
  createdById?: number;
  createdByName?: string;
  lastUpdatedBy?: string | number;
  lastUpdatedById?: number;
  lastUpdatedByName?: string;
};

export const convertSummaryToAppointmentEvent = (
  appointmentSummary: AppointmentSummary
) => {
  if (!appointmentSummary) return;

  const auditFields = appointmentSummary as AppointmentSummaryAuditFields;
  const createdById = auditFields.createdById;
  const createdByName =
    auditFields.createdByName ??
    (typeof auditFields.createdBy === 'string'
      ? auditFields.createdBy
      : undefined);
  const lastUpdatedById = auditFields.lastUpdatedById;
  const lastUpdatedByName =
    auditFields.lastUpdatedByName ??
    (typeof auditFields.lastUpdatedBy === 'string'
      ? auditFields.lastUpdatedBy
      : undefined);

  const durationInSeconds = dayjs(appointmentSummary.endDateTime).diff(
    appointmentSummary.startDateTime,
    'seconds'
  );

  const event: CalendarAppointmentEvent = {
    id: '',
    start: new Date(appointmentSummary?.startDateTime ?? 0),
    end: new Date(appointmentSummary?.endDateTime ?? 0),
    calendarId: '',
    planningEvent: {
      activity: {
        name: appointmentSummary.activity?.name,
        entityId: appointmentSummary.activity?.id,
        code: appointmentSummary.activity?.code,
        requiredQualifications: [],
        schedulingLabel: 'MRP'
      },
      clients: [
        ...(appointmentSummary.clients || []).map(
          ({ displayName }) =>
            ({
              id: '',
              fullName: displayName
            }) as ClientResponse
        )
      ],
      employees: [
        ...(appointmentSummary.employees || []).map(
          ({ displayName }) =>
            ({
              nameInformal: displayName
            }) as EmployeeResponse
        )
      ],
      date: appointmentSummary.startDateTime!,
      durationInSeconds,
      resources: [],
      isRecurring: false,
      recurrenceRuleRepresentation: '',
      createdById,
      createdByName,
      createdOn: appointmentSummary.createdOn,
      lastUpdatedById,
      lastUpdatedByName,
      lastUpdatedOn: appointmentSummary.lastUpdatedOn
    } as unknown as EventResponse,
    title: ''
  };

  return event;
};
